import report from "@report";
import { AxiosRequestConfig } from "axios";

function reportFn(type: string, url: string | number, value: string | number, kalo_json: object) {
  if (url !== "/api/log") {
    report.event("PerformanceResourceTiming", {
      kalo_pos: "search_list_" + type,
      kalo_type: url,
      kalo_value: value,
      kalo_json: kalo_json,
    });
  }
}

export class PerfResourceTiming {
  apiUrl: string;
  apiPath: string;
  requestTime: number;
  axiosParams: AxiosRequestConfig;
  performanceStart: number;

  constructor(apiUrl: string, axiosParams: AxiosRequestConfig) {
    this.apiUrl = window.location.origin + apiUrl;
    this.apiPath = apiUrl;
    this.axiosParams = axiosParams;
    this.requestTime = new Date().getTime();
    this.performanceStart = performance.now();
  }

  needReport() {
    let excludeURLs = ["/report", "/api", "/users", "/access"];
    for (let excludeURL of excludeURLs) {
      if (this.apiUrl.includes(excludeURL)) {
        return false;
      }
    }
    return true;
  }

  reportSuccess(response: any) {
    try {
      if (this.needReport()) {
        const status = response.status;
        const data = response.data;
        const traceID = response?.headers?.["x-amzn-trace-id"];
        const performanceEnd = performance.now();
        let performances = window.performance.getEntriesByName(this.apiUrl) as PerformanceResourceTiming[];
        performances = performances.filter((item) => {
          return (
            item.startTime >= this.performanceStart && item.responseEnd <= performanceEnd && this.apiUrl === item.name
          );
        });
        const perf = performances[performances.length - 1] || {};
        const duration = Math.floor(perf?.duration);
        if (duration) {
          reportFn("success", this.apiPath, duration, {
            apiUrl: this.apiUrl,
            reqParams: this.axiosParams.params,
            reqBody: this.axiosParams.data,
            resBody: {
              success: data?.success,
              code: data?.code,
              message: data?.message,
              cached: data?.cached,
              count: data?.data?.length,
            },
            status,
            performace: perf,
            performances: performances.length > 1 ? performances : null,
            traceID,
          });
        }
      }
    } catch (err) {}
  }

  reportFailed(response: any, errMsg?: any) {
    try {
      if (this.needReport()) {
        const status = response.status;
        const data = response.data;
        const traceID = response?.headers?.["x-amzn-trace-id"];
        const performanceEnd = performance.now();
        let performances = window.performance.getEntriesByName(this.apiUrl) as PerformanceResourceTiming[];
        performances = performances.filter(
          (item) => item.startTime >= this.performanceStart && item.responseEnd <= performanceEnd,
        );
        const perf = performances[performances.length - 1] || {};
        const duration = Math.floor(perf?.duration);
        if (duration) {
          reportFn("error", this.apiPath, duration, {
            apiUrl: this.apiUrl,
            reqParams: this.axiosParams.params,
            reqBody: this.axiosParams.data,
            resBody: {
              success: data?.success,
              code: data?.code,
              message: data?.message,
            },
            status: status,
            performace: perf,
            performances: performances.length > 1 ? performances : null,
            traceID,
            errMsg,
          });
        }
      }
    } catch (err) {}
  }
}
